module.exports = __webpack_public_path__ + "img/text.e6fea700.png";